export default __webpack_public_path__ + "static/media/loksabha agenda.084ad615.png";